const STORAGE_KEYS = {
  justLoggedIn: "hb_just_logged_in",
  preLoginUrl: "hb_pre_login_url",
};

function getConfig() {
  const root = document.querySelector(".login-page");
  return {
    accountUrl: root?.dataset.accountUrl || "/account",
    loginUrl: root?.dataset.loginUrl || "/account/login",
    registerUrl: root?.dataset.registerUrl || "/account/register",
    cartUrl: root?.dataset.cartUrl || "/cart",
  };
}

function pathOf(url) {
  try {
    return new URL(url, location.origin).pathname.replace(/\/$/, "") || "/";
  } catch {
    return "";
  }
}

function clearLoginIntent() {
  try {
    sessionStorage.removeItem(STORAGE_KEYS.justLoggedIn);
  } catch {}
}

function rememberPreLoginUrl() {
  if (sessionStorage.getItem(STORAGE_KEYS.justLoggedIn) || !document.referrer) return;

  try {
    const referrer = new URL(document.referrer);
    if (referrer.origin !== location.origin) return;
    // Sign in and create account are one page (snippets/customer-auth.liquid): neither is a page to go back to.
    const { loginUrl, registerUrl } = getConfig();
    if ([loginUrl, registerUrl].some((url) => pathOf(referrer.href) === pathOf(url))) return;

    sessionStorage.setItem(STORAGE_KEYS.preLoginUrl, referrer.pathname + referrer.search + referrer.hash);
  } catch {}
}

function markLoginIntent() {
  sessionStorage.setItem(STORAGE_KEYS.justLoggedIn, String(Date.now()));
}

function bindLoginIntent(form) {
  if (!form) return;

  form.addEventListener("submit", markLoginIntent);
  form
    .querySelectorAll("[name='sign-in-with-shop-provider'] a, [name='sign-in-with-shop-provider'] button")
    .forEach((element) => element.addEventListener("click", markLoginIntent));
}

function setLoginPendingRedirect(pending) {
  document.documentElement.style.visibility = pending ? "hidden" : "";
}

function redirectIfStillSignedIn() {
  const { accountUrl } = getConfig();

  // Don't paint the cached login UI while we confirm the session and redirect.
  setLoginPendingRedirect(true);

  fetch(accountUrl, { credentials: "same-origin", redirect: "follow" })
    .then((response) => {
      if (response.ok && response.url && pathOf(response.url) === pathOf(accountUrl)) {
        location.replace(getCartLoginReturn() || accountUrl);
        return;
      }
      setLoginPendingRedirect(false);
    })
    .catch(() => {
      setLoginPendingRedirect(false);
    });
}

function toggleRecover(showRecover) {
  const recoverSection = document.querySelector(".login-page .recover-section");
  const loginSection = document.querySelector(".login-page .login-section");
  if (!recoverSection || !loginSection) return;

  recoverSection.style.display = showRecover ? "block" : "none";
  loginSection.style.display = showRecover ? "none" : "block";
  scrollToTop();
}

function scrollToTop() {
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // Still on login ⇒ this attempt did not succeed (failed password, abandon reload, etc.)
  initCartLoginReturn();
  initStorefrontCustomerTokenCapture();
  clearLoginIntent();
  rememberPreLoginUrl();
  bindLoginIntent(document.querySelector(".login-page .login-section form"));

  document.querySelector(".forgot-password-link")?.addEventListener("click", () => toggleRecover(true));
  document.querySelector(".cancel-link")?.addEventListener("click", () => toggleRecover(false));

  if (location.hash?.substring(1) === "recover") {
    toggleRecover(true);
  } else {
    scrollToTop();
  }
});

window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    clearLoginIntent();
    redirectIfStillSignedIn();
  }
});

function getCartLoginReturn() {
  try {
    const params = new URLSearchParams(location.search);
    const returnUrl = params.get("return_url") || params.get("return_to");
    if (!returnUrl) return "";
    const destination = new URL(returnUrl, location.origin);
    if (destination.origin !== location.origin || /\/account(?:\/|$)/.test(destination.pathname)) return "";
    const cartUrl = new URL(getConfig().cartUrl, location.origin);
    if (destination.searchParams.get("hb_cart_drawer") !== "1" && destination.pathname !== cartUrl.pathname) return "";
    return destination.pathname + destination.search + destination.hash;
  } catch {
    return "";
  }
}

function initCartLoginReturn() {
  const destination = getCartLoginReturn();
  const form = document.querySelector(".login-page .login-section form");
  if (!destination || !form) return;
  let returnInput = form.querySelector('input[name="return_to"]');
  if (!returnInput) {
    returnInput = document.createElement("input");
    returnInput.type = "hidden";
    returnInput.name = "return_to";
    form.append(returnInput);
  }
  returnInput.value = destination;
  const register = form.querySelector(".create-account-link");
  if (register) {
    const url = new URL(register.href, location.origin);
    url.searchParams.set("return_to", destination);
    register.href = url.href;
  }
}

function initStorefrontCustomerTokenCapture() {
  // Only rendered when cart loyalty is enabled. Capturing on every
  // classic login means members who sign in from the header still reach the cart with a working
  // Okendo session on arrival at the cart.
  if (!document.querySelector("[data-okendo-loyalty-auth]")) return;
  const form = document.querySelector(".login-page .login-section form");
  if (!form || form.dataset.hbLoyaltyCapture) return;
  form.dataset.hbLoyaltyCapture = "1"; // one capture handler per form, however many times init runs
  let pending = false;
  let captured = false;
  form.addEventListener("submit", async (event) => {
    if (captured || !window.HbOkendoLoyalty) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    const button = event.submitter;
    if (button) button.disabled = true;
    try {
      await window.HbOkendoLoyalty.createCustomerAccessToken(
        form.elements["customer[email]"].value,
        form.elements["customer[password]"].value,
      );
    } catch {
      /* Shopify still completes its normal sign-in if loyalty is unavailable. */
    } finally {
      if (button) button.disabled = false;
      captured = true;
      pending = false;
      form.requestSubmit(button || undefined);
    }
  });
}
